import joinedSessionCue from '../assets/sounds/joinedSession.mp3';
import leftSessionCue from '../assets/sounds/leftSession.mp3';
import myLowerHandCue from '../assets/sounds/myLowerHand.mp3';
import myRaiseHandCue from '../assets/sounds/myRaiseHand.mp3';
import otherRaiseHandCue from '../assets/sounds/otherHandRaised.mp3';
import privateChatReceivedCue from '../assets/sounds/privateChatReceived.mp3';

export const notificationPreferenceDefinitions = [
  { key: 'myRaiseHandDing', label: 'Raising My Hand' },
  { key: 'otherRaiseHandDing', label: 'Others Raise Their Hand' },
  { key: 'myLowerHandDing', label: 'Hand is Lowered' },
  { key: 'joinedSessionDing', label: 'Someone Joined the Session' },
  { key: 'leftSessionDing', label: 'Someone Left the Session' },
  { key: 'privateChatReceivedDing', label: 'Received Private Chat' },
] as const;

export type NotificationPreferenceKey = (typeof notificationPreferenceDefinitions)[number]['key'];

export type NotificationPreferences = Record<NotificationPreferenceKey, boolean>;

export type MediaPreferences = {
  selectedAudioInput: string;
  selectedAudioOutput: string;
  selectedCamera: string;
};

export type AccessibilityTextSize = 'default' | 'large' | 'largest';

export type AccessibilityPreferences = {
  textSize: AccessibilityTextSize;
};

export type ViewerPreferences = {
  accessibility: AccessibilityPreferences;
  media: MediaPreferences;
  notifications: NotificationPreferences;
};

export const defaultAccessibilityPreferences: AccessibilityPreferences = {
  textSize: 'default',
};

export const defaultNotificationPreferences: NotificationPreferences = {
  joinedSessionDing: true,
  leftSessionDing: true,
  myLowerHandDing: true,
  myRaiseHandDing: true,
  otherRaiseHandDing: true,
  privateChatReceivedDing: true,
};

export const notificationCueSources: Record<NotificationPreferenceKey, string> = {
  joinedSessionDing: joinedSessionCue,
  leftSessionDing: leftSessionCue,
  myLowerHandDing: myLowerHandCue,
  myRaiseHandDing: myRaiseHandCue,
  otherRaiseHandDing: otherRaiseHandCue,
  privateChatReceivedDing: privateChatReceivedCue,
};
